import MarketShare from "./market-share";

export default MarketShare;
